<template>
  <section class="selection-grid wrap">
    <h2
      v-if="title"
      class="selection-grid__title"
    >
      {{ title }}
    </h2>
    <ExcursionCardList
      :exp-list="selection.experiences"
      :context-geo-subject="contextGeoSubject"
      :show-type="true"
    />
    <div class="selection-grid__btn">
      <ui-button
        :variant="UiButtonVariant.OUTLINE"
        :color-mode="UiButtonColorMode.NEUTRAL"
        text="Смотреть все"
        :to="muchMoreLink"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
  // Widgets
  import ExcursionCardList from '@/widgets/allCardsBlock/ui/excursion/ExcursionCardList.vue';

  // Features

  // Entities
  import type { IExpSelection } from '@/entities/expSelection/model/expSelection.ts';

  // Shared
  import type { ContextGeoSubject } from '@/shared/types/geography.ts';
  import { withMfsDomain } from '@/shared/lib/withMfsDomain';

  // External and shared packages
  import { UiButton, UiButtonColorMode, UiButtonVariant } from '@experience/core-button-ui';
  import { withoutDomain } from '@experience/shared';

  interface Props {
    selection: IExpSelection;
    contextGeoSubject: ContextGeoSubject;
  }

  const props = defineProps<Props>();

  const title = computed(() => props.selection.title ?? '');
  const muchMoreLink = computed(() => withMfsDomain(withoutDomain(props.selection.link)));
</script>

<style scoped lang="scss">
  @use '@experience/design-tokens/typography' as typography;
  @use '@experience/shared/dist/assets/adaptivity' as adaptivity;

  .selection-grid__title {
    margin-bottom: 24px;

    @include typography.base-800-750-extra;

    @include adaptivity.tablet {
      @include typography.base-700-500-extra;
    }

    @include adaptivity.mobile {
      margin-bottom: 20px;
    }
  }

  .selection-grid__btn {
    display: flex;
    justify-content: center;
  }
</style>
